<template>
  <div class="comp-top-bar bb-3">
    <div class="content">
      <div class="fl">
        <span>覆盖学校：<span class="text-second">{{topBarCounter.school || '-'}}</span></span>
        <span class="ml15">使用教师：<span class="text-second">{{topBarCounter.teacher || '-'}}</span></span>
        <span class="ml15">试题量：<span class="text-second">{{topBarCounter.test || '-'}}</span></span>
      </div>
      <div class="fr">
        <template v-if="!isLogin">
          <a href="javascript:" class="link" @click="bindGo('login')">登录</a>
          <a href="javascript:" @click="bindGo('register')" class="link ml15">注册</a>
        </template>
        <template v-if="isLogin">
          <span class="mr15">欢迎您 <router-link title="用户中心" :to="{name: 'User'}"
                                              class="link">{{nick}}</router-link></span>
          <a href="javascript:" class="link" @click="bindLogout">退出</a>
        </template>
        <span class="text-color-4 m15">|</span>
        <router-link :to="{name: 'HelpCenter'}" class="link">使用帮助</router-link>
        <!--<span class="text-color-4 m15">|</span>-->
        <!--<a href="http://devapi.wln100.com" target="_blank" class="link">考试在线</a>-->
        <span class="text-color-4 m15">|</span>
        <!--<span>客服：0371-61876380（周一至周五9:00-17:00）</span>-->
        <span><router-link :to="{name: 'HelpContact'}">联系我们</router-link></span>
<!--        <span><router-link :to="{name: 'HelpMessage'}">留言反馈</router-link></span>-->
<!--        <span><a target="_blank"-->
<!--                 href="//shang.qq.com/wpa/qunwpa?idkey=1d93fc398c3e993d6e6dbbccc5c49c7cd9a60aa837894e54b65f6a7156052899"><img-->
<!--                class="va-m" style="vertical-align: middle;" border="0" src="//pub.idqqimg.com/wpa/images/group.png"-->
<!--                alt="未来脑组卷在线" title="联系我们"></a></span>-->
      </div>
    </div>
  </div>
</template>

<script>
  /**
   * @author shaojingchao
   * @date 2019/2/15
   * @project zujuan-online
   * @desc
   */

  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import { removeToken, getToken } from '../utils/token'
  import { LOADING_CONFIG, LOGIN_URL, APPLICATION_ID, REGISTER_URL } from '../config'
  import { Base64UrlEncode } from '../utils'
  import { Loading } from 'element-ui'
  import { encryptString } from '../utils/encrypt-string'
  import { logoutApi } from '../api/login'

  export default {
    name: 'comp-top-bar',
    props: {},
    data () {
      return {}
    },
    computed: {
      ...mapGetters('common', ['topBarCounter']),
      ...mapGetters('user', ['isLogin', 'nickname', 'realName', 'phone']),
      nick () {
        return this.nickname == '未设置' ? encryptString(this.phone) || '未设置' : this.nickname
      }
    },
    created () {
      this.getHomeData()
    },
    methods: {
      ...mapMutations('common', ['goLogin']),
      ...mapMutations('user', ['updateIsLogin']),
      ...mapActions('common', ['getHomeData']),
      bindLogout () {
        let loading = Loading.service(Object.assign({}, LOADING_CONFIG, {text: '正在退出登录...'}))
        logoutApi({authorization: getToken()}).then(res => {
          removeToken()
          this.updateIsLogin(0)
          if (this.$route.meta.auth) {
            this.$router.replace({name: 'Index'}, () => {
              loading.close()
            }, () => {
              loading.close()
            })
          } else {
            loading.close()
          }
        }).catch(err => {
          loading.close()
        })
      },
      bindGo (tag) {
        let goUrl = tag === 'login' ? LOGIN_URL : REGISTER_URL
        let url = window.location.href
        window.location.href = goUrl + '?from=' + Base64UrlEncode(url) + '&id=' + APPLICATION_ID
      }
    }
  }
</script>

<style lang="less">
  .comp-top-bar {
    line-height: 34px;
    font-size: 12px;
    color: #666;
    height: 34px;
    background: rgba(250, 250, 250, 1);
    /*border-bottom:1px solid #eee;*/
  }
</style>
